module.exports = __webpack_public_path__ + "static/media/IMG_3928.c7c6c5d3.JPG";